module.exports = __webpack_public_path__ + "static/media/assembly_H1.ba7c7a08.png";